var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBespoke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.25 28.5625H37.541L38.791 32.9375H45.2053L46.4553 28.5625H50.75C51.2678 28.5625 51.6875 28.9822 51.6875 29.5V54.5C51.6875 55.0178 51.2678 55.4375 50.75 55.4375H33.25C32.7322 55.4375 32.3125 55.0178 32.3125 54.5V29.5C32.3125 28.9822 32.7322 28.5625 33.25 28.5625ZM39.491 28.5625H44.5052L43.791 31.0625H40.2053L39.491 28.5625ZM40.125 51.6875H43.875V49.8125H40.125V51.6875Z",
    fill: "#466AEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBespoke);
export default __webpack_public_path__ + "static/media/Bespoke.fb4f0c5b721066b5be6cb869c2fd4973.svg";
export { ForwardRef as ReactComponent };